import styled, { css } from "styled-components";
export const InfoViews2 = styled.section `
	.priceWrap {
		padding: 0 0.5rem;
		margin-top: 0.5rem;
		font-size: 0.75rem;
		.price {
			color: #ff3b30;
			font-weight: 500;
			font-family: "SFProText-Medium";
			font-size: 0.9375rem;
			line-height: 0.75rem;
		}
		.originalPrice {
			line-height: 1.125rem;
			font-size: 0.75rem;
			color: #999;
			font-family: "SFProText-Regular";
			font-weight: 400;
			text-decoration: line-through;
			margin-left: 0.25rem;
		}
	}
`;
export const NameViewBox = styled.p `
	color: #333;
	font-family: "SFProText-Regular";
	display: -webkit-box;
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
	font-weight: 400;
	overflow: hidden;
	${(props) => {
    if (props.col === 1) {
        return css `
				font-size: 0.875rem;
				line-height: 1.125rem;
				-webkit-line-clamp: 2;
			`;
    }
    return css `
			width: 100%;
			padding: 0 0.5rem;
			margin-top: 0.5rem;
			-webkit-line-clamp: 2;
			font-size: 0.75rem;
			line-height: 1.06rem;
			height: 2rem;
		`;
}}
`;
export const PcsViewsWrap = styled.section `
	font-size: 0.75rem;
	font-family: "Roboto-Regular";
	font-weight: 400;
	line-height: 0.875rem;
	text-align: center;
	.num {
		color: #f02;
	}
	.text {
		color: #666;
	}
`;
export const BuyNowViewBase = styled.section `
	text-align: center;
	color: #fff;
	font-size: 0.875rem;
	font-family: "SFProText-Regular";
	font-weight: 400;
	border-radius: 2px;
`;
export const BuyNowViewBox = styled(BuyNowViewBase) `
	${(props) => {
    if (props.col === 1) {
        return css `
				width: 5.6875rem;
				height: 2rem;
				margin-top: 0.25rem;
				line-height: 2rem;
			`;
    }
    return css `
			width: 4.875rem;
			height: 1.75rem;
			line-height: 1.75rem;
		`;
}}
`;
export const ClockViewBase = styled.section `
	display: flex;
	align-items: center;
	img {
		width: 0.6875rem;
		height: 0.75rem;
		display: block;
	}
	span {
		display: block;
		color: #f02;
		font-size: 0.875rem;
		font-family: "Roboto-Regular";
		font-weight: 400;
		line-height: 1rem;
		margin-left: 0.25rem;
	}
`;
export const ClockView1 = styled(ClockViewBase) `
	width: 100%;
	justify-content: center;
	line-height: 1rem;
	margin-bottom: 0.375rem;
`;
export const BottomView1 = styled.section `
	.bottomViewsBox {
		width: 100%;
		display: flex;
		justify-content: space-between;
		position: absolute;
		bottom: 0.625rem;

		.priceWrap {
			display: flex;
			flex-direction: column;
			justify-content: flex-end;

			.price {
				font-size: 0.9375rem;
				font-weight: 500;
				font-family: "SFProText-Medium";
				color: #ff3b30;
			}

			.originalPrice {
				font-size: 0.75rem;
				font-weight: 400;
				font-family: "SFProText-Regular";
				color: #999;
				text-decoration: line-through;
				line-height: 0.8125rem;
			}
		}
	}
`;
export const BottomView2 = styled.section `
	width: 100%;
	display: flex;
	align-items: flex-end;
	flex: 1 0 auto;

	.bottomViewsBox {
		width: 100%;
		padding: 0 0.5rem;
		margin: 0.5rem 0 0.75rem 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
`;
export const DiscountNum = styled.span `
	width: 2rem;
	height: 2rem;
	background: url("https://i.ezbuy.sg/FkxellgOv5amB-B13nI05JK-gOUS");
	background-size: 100% 100%;
	position: absolute;
	top: 0;
	right: 0;
	font-size: 0.625rem;
	font-family: "SFProText-Medium";
	font-weight: 500;
	color: #fff;
	line-height: 0.75rem;
	text-align: center;
	word-wrap: break-word;
	white-space: normal;
	padding-top: 0.125rem;
`;
export const SoldOutBox = styled.section `
	${(props) => {
    if (props.col === 1) {
        return css `
				img {
					width: 4.3125rem;
					height: 4.3125em;
					position: absolute;
					right: 0.75rem;
					bottom: 0.75rem;
				}
			`;
    }
    return css `
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.4);
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			img {
				width: 5.5625rem;
				height: 5.5625rem;
			}
		`;
}}
`;
